import DateView from 'react-datepicker';
import clsx from 'clsx';
import 'react-datepicker/dist/react-datepicker.css';
import {Field, ErrorMessage} from 'formik';

import TextError from './TextError';

function DatePicker(props: any) {
  const {label, name, labelOff = false, ...rest} = props;
  return (
    <div className='mb-7'>
      {!labelOff && (
        <label
          className={clsx('fw-bold fs-6 col-form-label', {required: props.required})}
          htmlFor={name}
        >
          {label}
        </label>
      )}
      <Field name={name}>
        {({form, field, meta}: any) => {
          const {setFieldValue} = form;
          const {value} = field;
          return (
            <DateView
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                {'is-invalid': meta.touched && meta.error},
                {
                  'is-valid': meta.touched && !meta.error,
                }
              )}
              id={name}
              {...field}
              {...rest}
              selected={value}
              onChange={(val: any) => {
                setFieldValue(name, val);
              }}
            />
          );
        }}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
}

export default DatePicker;
